module.exports = __webpack_public_path__ + "img/product_999.6d8eb42.webp";